import React from 'react'
import { CopyContainerProps } from './types'
import resolveProps from '../../utils/resolveProps'
import useCopyToClipboard from '../../hooks/useCopyToClipboard'
import useLocalStorage from '../../hooks/useLocalStorage'


const config = {
  types: [],
  modifiers: [],
  state: []
}

function CopyContainer(props: CopyContainerProps) {
  const { value } = props
  const [copiedText, copy] = useCopyToClipboard()

  return (
    <div className={`${resolveProps(props, config, 'CopyContainer')}`}
      onClick={() => copy(value)} >
      <div className="mdn-CopyContainer-content">
        <p
          className="mdn-CopyContainer-content-toCopy mdn-Heading mdn-Heading--xxs"
          mdn-copycontainer-value={value}
          mdn-copycontainer-after={`${copiedText === value
            ? 'Copiado'
            : 'Clique para copiar'}`}>
          {value}
        </p>
      </div>
      <div className="mdn-CopyContainer-icon">
        <span className="mdn-Icon-duplicar mdn-Icon--md"></span>
      </div>
    </div>
  )
}

export default CopyContainer
